// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { type EditLock, type EditLockWireFormat, NewEditLock } from '../EditLock/EditLock';

export class EditLockAcquisition {
  readonly held: EditLock[];
  readonly blocked: EditLock[];

  constructor(data: { [key: string]: any } = {}) {
    this.held = (data.held ?? []).map((held: any) => NewEditLock(held));
    this.blocked = (data.blocked ?? []).map((blocked: any) => NewEditLock(blocked));
  }

  static zero(): EditLockAcquisition {
    const zeroValues: ExcludeMethodsDeep<EditLockAcquisition> = {
      held: [],
      blocked: [],
    };
    return new EditLockAcquisition(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type EditLockAcquisitionWireFormat = {
  held: EditLockWireFormat[];
  blocked: EditLockWireFormat[];
};

type NewEditLockAcquisitionProps = PartialDeep<EditLockAcquisition, { recurseIntoArrays: true }>;
export const NewEditLockAcquisition: (props: NewEditLockAcquisitionProps) => EditLockAcquisition = (
  props,
) => new EditLockAcquisition(props);

type NewEditLockAcquisitionFromWireFormatProps = PartialDeep<
  EditLockAcquisitionWireFormat,
  { recurseIntoArrays: true }
>;
export const NewEditLockAcquisitionFromWireFormat: (
  props: NewEditLockAcquisitionFromWireFormatProps,
) => EditLockAcquisition = (props) => new EditLockAcquisition(props);
